import React from 'react';

import withIframeStyle from '../../containers/WithIframeStyle';
import CartIcon from '../../icons/CartIcon';
import { getRestaurantMenuFabStyle } from '../../utils/iframe-style-helper';

const cartIconStyle = { transform: 'translateX(-2px)' };

class RestaurantMenuCartFab extends React.Component {
  render() {
    const { cart, handleClick, iframeStyle } = this.props;
    if (cart.length) {
      return <button
        type="button"
        className="mr-2 mr-md-4 fab-btn fab-btn--big fab-btn--with-hover fab-btn--with-shadow"
        onClick={handleClick}
        style={iframeStyle}>
        <CartIcon style={cartIconStyle} />
        <span className="fab-btn__badge">{cart.length}</span>
      </button>
    }
    return null;
  }
}

export default withIframeStyle(RestaurantMenuCartFab, getRestaurantMenuFabStyle);
